import { useEffect } from 'react'
import { ModalCloseButton } from './ui/ModalCloseButton'

/**
 * Modale « bientôt disponible », partagée par les cartes du dashboard dont la source de données
 * n'existe pas encore (SUIVI SAV aujourd'hui ; PROCESS / CONTACT à câbler ensuite). Elle signale en
 * boutique que la fonctionnalité arrive sans faire croire à des données réelles.
 *
 * Même overlay que `CaDetailModal` : rendue DANS le canvas mis à l'échelle mais posée sur
 * `document.body` via `fixed`, donc hors du `transform: scale()` du dashboard. Aucun appel réseau.
 */
export function ComingSoonModal({ title, onClose }: { title: string; onClose: () => void }) {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [onClose])

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-[32px]"
      role="dialog"
      aria-modal="true"
      aria-label={`${title} — bientôt disponible`}
      onClick={onClose}
    >
      <div
        className="flex w-[520px] max-w-full flex-col gap-[16px] rounded-[20px] bg-[#F0EDE2] p-[32px] drop-shadow-[0px_8px_20px_rgba(0,0,0,0.15)]"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-center justify-between gap-[12px]">
          <div className="flex min-w-0 items-center gap-[12px]">
            <h2 className="truncate font-sans text-[22px] leading-[24px] font-semibold text-[#181D27] uppercase">
              {title}
            </h2>
            <span className="shrink-0 rounded-full border border-[#506B48] bg-[#F6F6F6] px-[15px] py-[9px] font-brand text-[16px] font-semibold whitespace-nowrap text-[#0C3A2D] uppercase">
              Bientôt disponible
            </span>
          </div>

          <ModalCloseButton onClose={onClose} />
        </div>

        <p className="font-sans text-[14px] leading-[20px] text-[#3E4F3F]">
          Cette fonctionnalité sera disponible prochainement.
        </p>
      </div>
    </div>
  )
}
